<template>
    <div>
        <div class="card dashcard mb-3">
            <div class="card-body">
                <div class="form-row">
                    <div class="col col-12 col-md-6">
                        <az-periodo v-model="filtro" :sync="true" @sync="load()" />
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input
                            type="select"
                            :optionsList="$util.unidades_com_tags(true, true)"
                            optionsData="id_unidade_operacao"
                            icon="fa fa-building fa-fw"
                            placeholder="Todas as Unidades..."
                            v-model="filtro.id_unidade_operacao" />
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input
                            icon="fa-solid fa-user-doctor"
                            placeholder="Profissional Solicitante..."
                            type="autocomplete"
                            optionsMode="aql"
                            service="medico_solicitantes.index"
                            optionsDisplay="search"
                            optionsData="id_medico_solicitante"
                            :optionsSync="true"
                            v-model="filtro.id_medico_solicitante" />
                    </div>
                </div>

                <div class="form-row mt-2">
                    <div class="col col-12 col-md-2">
                        <az-input
                            icon="fa-solid fa-arrow-down-a-z fa-fw"
                            placeholder="Ordem Alfabética"
                            type="select"
                            :optionsList="[
                                { id: 'consultas', search: 'Ordem Consultas' }, 
                                { id: 'relac', search: 'Ordem Relação' }, 
                                { id: 'solics', search: 'Ordem Solicitação' }, 
                            ]"
                            optionsData="id"
                            v-model="filtro.ordem" />
                    </div>
                    <div class="col col-12 col-md-4">
                        <az-input
                            icon="fa-solid fa-object-group"
                            placeholder="Agrupar por Classe"
                            type="select"
                            :optionsList="[
                                { id: 'especialidade', search: 'Agrupar por Especialidade' }, 
                                { id: 'unidade', search: 'Agrupar por Unidade' }, 
                            ]"
                            optionsData="id"
                            v-model="filtro.grupo" />
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input 
                            placeholder="Todas as Especialidades..."
                            icon="fas fa-filter fa-fw" 
                            type="select" 
                            optionsMode="esp-ativas"
                            optionsName="esp-ativas"
                            optionsData="id_especialidade"
                            v-model="filtro.id_especialidade"  />
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input 
                            placeholder="Todas as Classificações..."
                            icon="fas fa-filter fa-fw" 
                            type="select"
                            optionsData="id_classe_procedimento"
                            service="classe_procedimentos.index"
                            optionsMode="aql"
                            v-model="filtro.id_classe_procedimento" />
                    </div>
                </div>
            </div>
        </div>

        <div v-if="!dados">
            <az-empty-state msg="Nenhum Solicitante Identificado." />
        </div>

        <template v-else>

            <table class="table table-sm border-0 table-responsive mb-1" v-if="dados && dados.lista_classes && dados.lista_classes.length">
                <tr>
                    <td class="text-nowrap">
                        <a href="#" @click.prevent="classe_selecionada == classe ? classe_selecionada = null : classe_selecionada = classe" v-for="(classe, icx) in dados.lista_classes" :key="icx">
                            <span class="badge mr-1" :class="classe == classe_selecionada ? 'badge-success' : 'badge-secondary'">
                                {{ classe }}
                            </span>
                        </a>
                    </td>
                </tr>
            </table>
        
            <table class="table bg-white table-hover small cabecalho-fixo">
                <thead>
                    <tr>
                        <th>Solicitante</th>
                        <th class="text-right">Consultas</th>
                        <th class="text-right">Solicitações</th>
                        <th class="text-right">Relação</th>
                        <th class="text-right" v-for="(coluna, icx) in dados.colunas" :key="icx">
                            {{ coluna }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(itens, medico, imx) in dados.lista">
                        <tr :key="imx" v-if="!classe_selecionada || ( itens[0].medico_solicitante.js_classes && itens[0].medico_solicitante.js_classes.find(sc => sc == classe_selecionada) )">
                            <td>
                                {{ medico }}
                                <div v-if="itens[0].medico_solicitante && itens[0].medico_solicitante.js_classes">
                                    <a href="#" @click.prevent="classe_selecionada == classe ? classe_selecionada = null : classe_selecionada = classe" v-for="(classe, icx) in itens[0].medico_solicitante.js_classes" :key="icx">
                                        <span class="badge badge-success mr-1" >
                                            {{ classe }}
                                        </span>
                                    </a>
                                </div>
                            </td>
                            <td class="text-right">
                                <template v-if="itens[0].qtde_consultas.qtde > 0">
                                    {{ $util.formatMoeda(itens[0].qtde_consultas.valor) }}
                                    <div class="text-muted">
                                        {{ itens[0].qtde_consultas.qtde }}
                                    </div>
                                </template>
                            </td>
                            <td class="text-right">
                                {{ $util.formatMoeda(totalizar(itens, 'valor')) }}
                                <div class="text-muted">
                                    {{ totalizar(itens, 'qtde') }}
                                </div>
                            </td>
                            <td class="text-right">
                                <template v-if="itens[0].qtde_consultas.qtde > 0">
                                    {{ $util.formatMoeda(totalizar(itens, 'valor') / itens[0].qtde_consultas.qtde) }} 
                                    <div class="text-muted">
                                        {{ $util.formatMoeda(totalizar(itens, 'qtde') / itens[0].qtde_consultas.qtde, 1) }}
                                    </div>
                                </template>
                            </td>
                            <td class="text-right" v-for="(coluna, icx) in dados.colunas" :key="icx">
                                <div v-if="get_campo(itens, coluna, 'qtde')">
                                    {{ $util.formatMoeda(get_campo(itens, coluna, 'valor')) }}
                                    <div class="text-muted">
                                        {{ get_campo(itens, coluna, 'qtde') }}
                                    </div>
                                    <div class="text-muted" v-if="1 == 0 && itens[0].qtde_consultas.qtde > 0">
                                        Relação {{ $util.formatMoeda(get_campo(itens, coluna, 'valor') / itens[0].qtde_consultas.qtde) }}
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>

            <template v-if="1 == 0">

                <div class="row" v-if="dados">
                    <div class="col col-12 col-md-6">
                        <pre>{{ dados.lista }}</pre>
                    </div>
                    <div class="col col-12 col-md-6">
                        <pre>{{ dados.consultas }}</pre>
                    </div>
                </div>

                <pre class="alert alert-info">{{ dados }}</pre>

            </template>

        </template>
    </div>
</template>

<script>
import _ from 'lodash';
import AzInput from '../../shared/forms/AzInput.vue';
import AzPeriodo from '../../shared/forms/AzPeriodo.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';

export default {
    data() {
        return { 
            dados: null, 
            filtro: { 
                periodo: 'ma', 
                id_unidade_operacao: "", 
                id_medico_solicitante: "", 
                id_especialidade: "", 
                id_classe_procedimento: "", 
                grupo: "", 
                ordem: "", 
            },
            classe_selecionada: "", 
            lista_classes: [], 
        };
    },

    components: { 
        AzInput,
        AzPeriodo,
        AzEmptyState, 
    },

    methods: { 
        totalizar (lista, campo) { 
            return lista.reduce((total, carry) => { 
                return total + parseFloat(_.get(carry, campo, 0));
            }, 0);
        },

        get_campo(itens, coluna, campo) { 
            return _.get(itens.find(item => item.st_classe_procedimento == coluna), campo);
        },

        load() { 
            this.$util.load(this, { 
                service: 'crm',
                func: 'index_solicitante',
                parms: { 
                    ...this.filtro, 
                },
                loadTo: res => { 
                    this.dados = res;
                },
            });
        }
    },

    mounted() { 
        this.$store.commit("setBreadcrumb", [
            { name: "CRM", path: "/crm" },
            { name: "Solicitantes", path: "/crm/solics" }
        ]);
    }
}
</script>
